import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import RegistrationForm from "../components/RegistrationForm";
import Footer from "../components/Footer";
import AlertPopup from "../components/AlertPopup";
import bandeau_campus_CMH from "../assets/images/bandeau_campus_CMH.png";

const HomePage: React.FC = () => {
  const { token } = useParams<{ token?: string }>();
  const [alert, setAlert] = useState<string>("");
  const [showAlert, setShowAlert] = useState<boolean>(false);

  const handleAlert = (message: string) => {
    setAlert(message);
    setShowAlert(true);
  };

  useEffect(() => {
    if (showAlert) {
      const timer = setTimeout(() => {
        setShowAlert(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [showAlert]);

  if (!token) {
    return (
      <div>
        <img src={bandeau_campus_CMH} alt="Banner" className="banner" />
        <div className="BlockErreurBlue">
          <h1>Erreur</h1>
          <p>
            Nous vous prions de revenir à cette page avec votre lien
            personnalisé
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center"}}>
      <header>
        <img src={bandeau_campus_CMH} alt="Banner" className="banner" />
      </header>
      <RegistrationForm token={token} onAlert={handleAlert} />
      <Footer />
      {/* <div className="ContainerV2">
        <div className="ContainerV2In2">
        </div>
      </div>
      <div style={{ marginTop: '50px' }}>
      </div> */}
      {showAlert && (
        <AlertPopup message={alert} onClose={() => setShowAlert(false)} />
      )}
    </div>
  );
};

export default HomePage;
